// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { getSalesGoalInformation } from "@stoneage/App/Services/SalesGoal/SalesGoalService";

interface Props {
    apiParameter: any;
    apiResult: {
        uri: string;
        annualSalesGoal: number;
        annualSalesGoalDisplay: string;
        yearToDate: number;
        yearToDateDisplay: string;
        properties: any;
        successful: boolean;
        error?: any;
    };
}

type Parameter = {
    onSuccess?: (result: any) => void;
    onError?: (e: any) => void;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getSalesGoalInformation();
};

export const onSuccess: HandlerType = props => {
    if (props.apiResult && props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const OnError: HandlerType = props => {
    if (props.apiResult && !props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult);
    }
};

export const chain = [PopulateApiParameters, RequestDataFromApi, onSuccess, OnError];

const getSalesGoalData = createHandlerChainRunner(chain, "GetSalesGoalData");
export default getSalesGoalData;
